import React from "react";
import { Route, Routes, Navigate } from "react-router-dom";
import LazyLoader from "../components/common/Loader/LazyLoader";
import PrivateRoute from "./PrivateRoute";
import RecruiterCandidateList from "../pages/Recruiter/CandidateList/RecruiterCandidateList";
import DeleteSegment from "../pages/Admin/DeleteAccount/DeleteSegment";
import DummyForm from "../pages/Recruiter/Enrollment/DummyForm";
import AdminPayoutDetails from "../pages/Admin/AdminPayout/AdminPayoutDetails";
import OfferDeclineCandidatePage from "../pages/Admin/OfferDecline/OfferDeclineCandidatePage";
import RejectedCandidates from "../pages/Admin/RejectedCandidate/RejectedCandidates";
import ContactUs from "../pages/Admin/ContactUs/ContactUs";
// import Settings from "../pages/Admin/Setting/Settings";

const AdminDashBoard = LazyLoader(() =>
  import("../pages/Admin/AdminDashboard/AdminDashBoard")
);
const AdminLayout = LazyLoader(() =>
  import("../pages/Admin/Layout/Adminlayout")
);
const AdminDetails = LazyLoader(() =>
  import("../pages/Admin/Admin User/AdminDetails")
);
const RecruiterPage = LazyLoader(() =>
  import("../pages/Admin/Lists/RecruiterPage")
);
const ReportsPage = LazyLoader(() => import("../pages/Dashboard/ReportsPage"));
const ClientPage = LazyLoader(() => import("../pages/Admin/Lists/ClientPage"));
const CandidatePage = LazyLoader(() =>
  import("../pages/Admin/Lists/CandidatePage")
);
const AdminProfile = LazyLoader(() =>
  import("../pages/Admin/Profile/AdminProfile")
);
const AdminPrivateRoute = LazyLoader(() => import("./AdminPrivateRoute"));
const CandidateEnrollMentForm = LazyLoader(() =>
  import("../pages/Admin/CandidateEnrollMent/CandidateEnrollMentForm")
);
const UnauthorizedPage = LazyLoader(() =>
  import("../pages/NotFound/UnauthorizedPage")
);
const SubscriptionPage = LazyLoader(() =>
  import("../pages/Admin/Subscriptions/SubscriptionPage")
);
const AddSubscription = LazyLoader(() =>
  import("../pages/Admin/Subscriptions/AddSubscription")
);
const Logs = LazyLoader(() => import("../pages/Admin/Logs/Logs"));
const ShortListedCandidate = LazyLoader(() =>
  import("../pages/Client/ShortListedCandidate/ShortListedCandidate")
);
const AdminReport = LazyLoader(() =>
  import("../pages/Admin/AdminReports/AdminReport")
);
const Services = LazyLoader(() => import("../pages/Admin/Services/Services"));
const HireCandidate = LazyLoader(() =>
  import("../pages/Admin/HireCandidate/HireCandidate")
);
const CandidateResumeConfirmation = LazyLoader(() =>
  import("../pages/NotFound/CandidateResumeConfirmation")
);
const Subscription = LazyLoader(() =>
  import("../pages/Subscription/Subscription")
);
const CandidateViewDetail = LazyLoader(() =>
  import("../pages/Client/ClientSearch/CandidateViewDetail")
);
const DummyDate = LazyLoader(() => import("../pages/Admin/Logs/DummyDate"));
const StripeConnect = LazyLoader(() =>
  import("../pages/NotFound/StripeConnect")
);
const ClientReports = LazyLoader(() =>
  import("../pages/Client/ClientReports/ClientReports")
);
const ClientPayment = LazyLoader(() =>
  import("../pages/Payment/ClientPayment")
);
const SearchHistory = LazyLoader(() =>
  import("../pages/Client/ClientHistory/SearchHistory")
);
const SearchProfile = LazyLoader(() =>
  import("../pages/Client/ClientSearch/SearchProfile")
);
const RecruterReports = LazyLoader(() =>
  import("../pages/Recruiter/RecruterReports/RecruterReports")
);
const SubscriptionSuccessMsg = LazyLoader(() =>
  import("../pages/Subscription/SubscriptionSuccessMsg")
);

const SubmitCandidatePage = LazyLoader(() =>
  import("../pages/Recruiter/Enrollment/SubmitCandidatePage")
);
const LoginPage = LazyLoader(() => import("../pages/Auth/LoginPage"));
const NotFoundPage = LazyLoader(() => import("../pages/NotFound/NotFoundPage"));
const SignupPage = LazyLoader(() => import("../pages/Auth/SignupPage"));
const AuthLayout = LazyLoader(() =>
  import("../components/Layout/AuthLayout/AuthLayout")
);
const AdminLogin = LazyLoader(() => import("../pages/Admin/Auth/AdminLogin"));
const ForgotPasswordPage = LazyLoader(() =>
  import("../pages/Auth/ForgotPasswordPage")
);
const ChangePasswordPage = LazyLoader(() =>
  import("../pages/Auth/ChangePasswordPage")
);
const OtpPage = LazyLoader(() => import("../pages/Auth/OtpPage"));
const ContractDetailsPage = LazyLoader(() =>
  import("../pages/Auth/ContractDetailsPage")
);
const ProfilePage = LazyLoader(() => import("../pages/Profile/ProfilePage"));
const DashboardPage = LazyLoader(() =>
  import("../pages/Dashboard/DashboardPage")
);
const MainLayout = LazyLoader(() =>
  import("../components/Layout/MainLayout/MainLayout")
);

const RouteConfig = () => {
  return (
    <> 
      <Routes>
        <Route path="/" element={<Navigate to="/recruiter" />} />
        <Route element={<AuthLayout />}>
          <Route path="/recruiter" element={<LoginPage />} />
          <Route path="/client" element={<LoginPage />} />
          <Route path="/signup" element={<SignupPage />} />
          <Route path="/forgot-password" element={<ForgotPasswordPage />} />
          <Route path="/client-payment" element={<ClientPayment />} />
          {/* <Route path="/otp" element={<OtpPage />} /> */}
          <Route path="/change-password" element={<ChangePasswordPage />} />
        </Route>
        <Route
          element={
            <PrivateRoute allowedRoles={["recruiter", "client"]}>
              <AuthLayout />
            </PrivateRoute>
          }
        >
          <Route path="/contract-details" element={<ContractDetailsPage />} />
          <Route path="/user-subscription" element={<Subscription />} />
          <Route
            path="/subscription-success/:user_id?"
            element={<SubscriptionSuccessMsg />}
          />
          <Route path="/reauth" element={<StripeConnect />} />
        </Route>
        <Route
          element={
            <PrivateRoute allowedRoles={["recruiter", "client"]}>
              <MainLayout />
            </PrivateRoute>
          }
        >
          <Route path="/dashboard" element={<DashboardPage />} />
          <Route
            path="/candidate-details/:can_id"
            element={<CandidateViewDetail />}
          />
          <Route
            path="/candidate-view-details/:can_id"
            element={<CandidateViewDetail />}
          />
          <Route path="/profile" element={<ProfilePage />} />
          <Route path="/client-reports" element={<ClientReports />} />
          <Route path="/recruiter-reports" element={<RecruterReports />} />
          <Route
            path="/change-subscription/:plainId"
            element={<Subscription />}
          />
        </Route>
        <Route
          element={
            <PrivateRoute allowedRoles={["recruiter"]}>
              <MainLayout />
            </PrivateRoute>
          }
        >
          <Route
            path="/candidate-enrollment"
            element={<SubmitCandidatePage />}
          />

          <Route
            path="/recruiter-candidate-list"
            element={<RecruterReports />}
          />
        </Route>
        <Route
          element={
            <PrivateRoute allowedRoles={["client"]}>
              <MainLayout />
            </PrivateRoute>
          }
        >
          <Route
            path="/short-listed-candidate"
            element={<ShortListedCandidate />}
          />
          <Route path="/client-search-history" element={<SearchHistory />} />
          <Route
            path="/search-history/:search_id?"
            element={<SearchProfile />}
          />
        </Route>

        <Route path="*" element={<NotFoundPage />} />
        <Route path="/unauthorized" element={<UnauthorizedPage />} />
        <Route path="/candidate-form" element={<DummyForm />} />
        <Route
          path="/candidate-confirmation"
          element={<CandidateResumeConfirmation />}
        />

        {/* Admin */}
        <Route path="/admin" element={<AdminLogin />} />
        <Route
          element={
            <AdminPrivateRoute>
              <AdminLayout />
            </AdminPrivateRoute>
          }
        >
          <Route path="/admin-dashboard" element={<AdminDashBoard />} />
          <Route path="/admin-user" element={<AdminDetails />} />
          <Route path="/recruiter-details" element={<RecruiterPage />} />
          <Route path="/client-details" element={<ClientPage />} />
          <Route path="/candidate-details" element={<CandidatePage />} />
          <Route
            path="/admin-can-detail/:can_id"
            element={<CandidateViewDetail />}
          />
          <Route path="/admin-profile" element={<AdminProfile />} />
          <Route
            path="/admin-candidate-form/:candidateId?"
            element={<CandidateEnrollMentForm />}
          />
          <Route path="/subscription" element={<SubscriptionPage />} />
          <Route path="/logs" element={<Logs />} />
          <Route path="/admin-reports" element={<AdminReport />} />
          <Route path="/services" element={<Services />} />
          <Route path="/hire-candidate" element={<HireCandidate />} />
          <Route path="/dummy" element={<DummyDate />} />
          <Route path="/Deleted-User" element={<DeleteSegment />} />
          <Route path="/payout-details" element={<AdminPayoutDetails />} />
          <Route
            path="/offer-decline"
            element={<OfferDeclineCandidatePage />}
          />
          <Route path="/rejected-candidates" element={<RejectedCandidates />} />
          <Route path="/contact-us" element={<ContactUs />} />
        </Route>
      </Routes>
    </>
  );
};

export default RouteConfig;
